const KEY = 'recentVehicles';
const MAX = 8;
export const RECENT_VEHICLES_EVENT = 'recent-vehicles-changed';

// Recently viewed vehicle models (brand page zoom / model page) — appended to the touch gallery and shown on home
export const getRecentVehicles = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

const notify = () => window.dispatchEvent(new Event(RECENT_VEHICLES_EVENT));

export const pushRecentVehicle = (item) => {
  if (!item?.src) return;
  const entry = { src: item.src, alt: item.alt || '', url: item.url || '' };
  const next = [entry, ...getRecentVehicles().filter((x) => x.src !== entry.src)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
  notify();
};

export const clearRecentVehicles = () => {
  localStorage.removeItem(KEY);
  notify();
};
